/* eslint func-style: "off" */

import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  //actions
  FETCH_SHARED_TOKENS, UPDATE_SHARED_TOKEN, DELETE_SHARED_TOKEN,
  // action creators
  fetchSharedTokensSucceeded, fetchSharedTokensFailed,
  updateSharedTokenSucceeded, updateSharedTokenFailed,
  deleteSharedTokenSucceeded, deleteSharedTokenFailed } from './DashboardLinkAccess.ducks';
import apiClient from 'helpers/apiClient';

const fetchSharedTokens = function* ({campaignId}) {
  try {
    const path = `/api/campaigns/${campaignId}/sharedTokens`;
    const payload = yield call(apiClient, path);
    yield put(fetchSharedTokensSucceeded(payload));
  } catch (e) {
    yield put(fetchSharedTokensFailed(e.body));
  }
};

const updateSharedToken = function* (action) {
  try {
    const { _id: sharedTokenId, campaignId } = action.payload;
    const path = `/api/campaigns/${campaignId}/sharedTokens/${sharedTokenId}`;
    const payload = yield call(apiClient, path, {
      method: 'PUT',
      body: JSON.stringify(action.payload)
    });
    yield put(updateSharedTokenSucceeded(payload));
  } catch (e) {
    yield put(updateSharedTokenFailed(e.body));
  }
};

const deleteSharedToken = function* (action) {
  const { campaignId, _id: sharedTokenId } = action.payload;
  try {
    const path = `/api/campaigns/${campaignId}/sharedTokens/${sharedTokenId}`;
    const payload = yield call(apiClient, path, {
      method: 'DELETE'
    });
    yield put(deleteSharedTokenSucceeded(payload));
  } catch (e) {
    yield put(deleteSharedTokenFailed(e.body));
  }
};

const fetchSharedTokensSaga = function* () {
  yield takeLatest( FETCH_SHARED_TOKENS, fetchSharedTokens);
};

const updateSharedTokenSaga = function* () {
  yield takeLatest( UPDATE_SHARED_TOKEN, updateSharedToken);
};

const deleteSharedTokenSaga = function* () {
  yield takeLatest( DELETE_SHARED_TOKEN, deleteSharedToken);
};

const sagas = function* () {
  yield all([
    fork(fetchSharedTokensSaga),
    fork(updateSharedTokenSaga),
    fork(deleteSharedTokenSaga)
  ]);
};

export {
  fetchSharedTokens,
  updateSharedToken,
  deleteSharedToken,
  fetchSharedTokensSaga,
  updateSharedTokenSaga,
  deleteSharedTokenSaga
};

export default sagas;
